<template>

    <div v-if="loaded">
        <div class="nav-tabs-custom submenu">
            <ul class="nav nav-tabs nav-fixed-tabs">
                <li
                    v-for="child in getMenu"
                    :class="{'active':isActiveChildRoute(child)}"
                >
                    <router-link :to="routeTo(child)">
                        {{ child.name }}
                    </router-link>
                </li>
                <li class="pull-right">
                    <router-link
                        v-if="shouldShowAddSubProjectButton"
                        :to="{name:'projects.add.subproject', params: {project_uuid:this.project.uuid}}"
                        class="btn btn-box-tool pull-right"
                        v-tooltip="'Subproject toevoegen'"
                    >
                        <i class="fa fa-plus"></i>
                        <span class="sr-only">Subproject toevoegen</span>
                    </router-link>
                </li>
            </ul>
        </div>

        <router-view
            @reloadProjectData="reload"
        ></router-view>
    </div>
    <div v-else>
        <loader></loader>
    </div>

</template>

<script>

import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';
import Lang from '../../../Lang';
import MenuItem from "../../../Libraries/MenuItem";
import FixedTabs from "../../../Libraries/FixedTabs";
import Loader from "../../../components/Common/Loader";

export default {

    components: {
        Loader,
    },

    computed: {
        ...mapGetters([
            'getProject',
            'moduleIsActive',
            'hasSubMenu',
        ]),

        getMenu() {
            let menu = [
                new MenuItem(this.getProject.number + ' – ' + this.getProject.name, {name:'projects.details.index', params:{project_uuid:this.getProject.uuid}}),
                new MenuItem(Lang.get('projects.tabs.tasks'), {name:'projects.details.tasks', params:{project_uuid:this.getProject.uuid}}),
                new MenuItem(Lang.get('projects.tabs.planning'), {name:'projects.details.planning', params:{project_uuid:this.getProject.uuid}}),
                new MenuItem(Lang.get('projects.tabs.contacts'), {name:'projects.details.contacts', params:{project_uuid:this.getProject.uuid}}),
            ];

            if (this.moduleIsActive('documents')) {
                menu.push(new MenuItem(Lang.get('projects.tabs.documents'), {name:'projects.details.documents', params:{project_uuid:this.getProject.uuid}}));
            }

            menu.push(new MenuItem(Lang.get('projects.tabs.hours'), {name:'projects.details.hours', params:{project_uuid:this.getProject.uuid}}));
            menu.push(new MenuItem(Lang.get('projects.tabs.hourstotals'), {name:'projects.details.hourtotals', params:{project_uuid:this.getProject.uuid}}));

            if (this.moduleIsActive('images')) {
                menu.push(new MenuItem(Lang.get('projects.tabs.images'), {name:'projects.details.images', params:{project_uuid:this.getProject.uuid}}));
            }

            if (this.getProject.access.budgets === true) {
                menu.push(new MenuItem(Lang.get('projects.tabs.budgets'), {name:'projects.details.budgets', params:{project_uuid:this.getProject.uuid}}));
            }

            if (this.getProject.access.finance === true) {
                menu.push(new MenuItem(Lang.get('projects.tabs.invoices'), {name:'projects.details.invoices', params:{project_uuid:this.getProject.uuid}}));
            }

            return menu;
        },

        project() {
            return this.getProject;
        },

        shouldShowAddSubProjectButton() {
            return this.project.is_main_project &&
                this.project.is_project &&
                this.project.access.create;
        },
    },

    data() {
        return {
            Lang:Lang,
            loaded:false,
        }
    },

    destroyed(){
        FixedTabs.unset();
        this.setHasSubMenu(false);
        this.resetProject();
    },

    methods: {
        ...mapActions([
            'setProject',
            'resetProject',
            'setHasSubMenu',
        ]),

        isActiveChildRoute(child) {
            let routeName;
            if (typeof child.route === 'string') {
                routeName = child.route;
            } else {
                routeName = child.route.name;
            }

            if (routeName == 'projects.details.index' && this.$route.name == 'projects.details.edit') {
                return true;
            }

            return routeName === this.$route.name;
        },

        getProjectData() {
            axios.get(this.route('api.v1.projects.show', {project_uuid: this.$route.params.uuid}))
                .then(resp => {
                    this.setProject(resp.data.data);
                    this.loaded = true;
                })
                .catch(() => this.$snotify.error('Er is een fout opgetreden bij het ophalen van het project'));
        },

        reload() {
            this.loaded = false;
            this.getProjectData();
        },

        routeTo(child) {
            if (typeof child.route === 'string') {
                return {name:child.route};
            }
            return {
                name:child.route.name,
                params:child.route.params,
            };
        },
    },

    mounted(){
        FixedTabs.set();
        this.setHasSubMenu(true);
        this.getProjectData();
    },

    name:'ProjectsDetailsLayout',

}

</script>
